import Lookup from '../componentes/select2';

const SeparadorNumerico = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/SeparadorNumericoLookup"
      clearable={false}
      {...props}
    />
  );
};

export default SeparadorNumerico;
